export function convertToPresenceWithInstitution(data) {
  return {
    ...data,
    institution: {
      shortName: data.institutionShortName,
      name: data.institutionName,
    },
  };
}
